import { QueryKey } from '@/application/queryKeys';
import { isGnosisSafe } from '@/infrastructure/utils/isGnosisSafe';
import { useQuery } from '@tanstack/react-query';

/**
 * Hook to know if the app is run in a safe app context.
 */
export const useIsSafeApp = () => {
  return useQuery<boolean>(
    [QueryKey.IS_SAFE_APP],
    async (): Promise<boolean> => {
      return isGnosisSafe();
    }
  );
};
